var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	41710: {
		fallback: function() { return __webpack_require__.e(2142).then(function() { return function() { return __webpack_require__(32142); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	5954: {
		fallback: function() { return __webpack_require__.e(1414).then(function() { return function() { return __webpack_require__(1414); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	79803: {
		fallback: function() { return Promise.all([__webpack_require__.e(9509), __webpack_require__.e(3208), __webpack_require__.e(8437), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(18437); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	9270: {
		fallback: function() { return Promise.all([__webpack_require__.e(9509), __webpack_require__.e(200)]).then(function() { return function() { return __webpack_require__(60200); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	13048: {
		fallback: function() { return Promise.all([__webpack_require__.e(3208), __webpack_require__.e(8766), __webpack_require__.e(811)]).then(function() { return function() { return __webpack_require__(56575); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	63720: {
		fallback: function() { return Promise.all([__webpack_require__.e(9451), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(19451); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	8680: {
		fallback: function() { return __webpack_require__.e(8651).then(function() { return function() { return __webpack_require__(8651); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	56549: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(13274); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	668: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(79474); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	14475: {
		fallback: function() { return __webpack_require__.e(7899).then(function() { return function() { return __webpack_require__(87899); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	68153: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(48088); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	28766: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(41615); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	98037: {
		fallback: function() { return __webpack_require__.e(7490).then(function() { return function() { return __webpack_require__(17490); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "8.3.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	17799: {
		fallback: function() { return __webpack_require__.e(8234).then(function() { return function() { return __webpack_require__(15853); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	3505: {
		fallback: function() { return Promise.all([__webpack_require__.e(8859), __webpack_require__.e(3299), __webpack_require__.e(5695), __webpack_require__.e(3526)]).then(function() { return function() { return __webpack_require__(25797); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^8.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	69754: {
		fallback: function() { return Promise.all([__webpack_require__.e(8859), __webpack_require__.e(3299), __webpack_require__.e(5695), __webpack_require__.e(3526)]).then(function() { return function() { return __webpack_require__(25797); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "8.3.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	92692: {
		fallback: function() { return __webpack_require__.e(8234).then(function() { return function() { return __webpack_require__(15853); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	61859: {
		fallback: function() { return __webpack_require__.e(8234).then(function() { return function() { return __webpack_require__(15853); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	82080: {
		fallback: function() { return Promise.all([__webpack_require__.e(7277), __webpack_require__.e(7029)]).then(function() { return function() { return __webpack_require__(72997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.55.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@hackler/react-sdk",
	},
	22408: {
		fallback: function() { return __webpack_require__.e(8651).then(function() { return function() { return __webpack_require__(8651); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	53134: {
		fallback: function() { return __webpack_require__.e(8234).then(function() { return function() { return __webpack_require__(15853); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.9.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	66800: {
		fallback: function() { return __webpack_require__.e(1414).then(function() { return function() { return __webpack_require__(1414); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	89104: {
		fallback: function() { return __webpack_require__.e(8234).then(function() { return function() { return __webpack_require__(15853); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	14083: {
		fallback: function() { return __webpack_require__.e(8234).then(function() { return function() { return __webpack_require__(15853); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	29373: {
		fallback: function() { return Promise.all([__webpack_require__.e(7277), __webpack_require__.e(7029)]).then(function() { return function() { return __webpack_require__(72997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.37.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@hackler/react-sdk",
	},
	65780: {
		fallback: function() { return __webpack_require__.e(7819).then(function() { return function() { return __webpack_require__(60200); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	79523: {
		fallback: function() { return __webpack_require__.e(7490).then(function() { return function() { return __webpack_require__(17490); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^8.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	38147: {
		fallback: function() { return __webpack_require__.e(7490).then(function() { return function() { return __webpack_require__(17490); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "8.3.18",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	91768: {
		fallback: function() { return Promise.all([__webpack_require__.e(8859), __webpack_require__.e(3299), __webpack_require__.e(5695)]).then(function() { return function() { return __webpack_require__(25797); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "8.3.18",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	53026: {
		fallback: function() { return __webpack_require__.e(7490).then(function() { return function() { return __webpack_require__(17490); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^8.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	84048: {
		fallback: function() { return __webpack_require__.e(6575).then(function() { return function() { return __webpack_require__(56575); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	16187: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(49906); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/server",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [41710,5954,79803,9270,13048,63720,8680,56549,668,14475,56549,668,68153,28766,17799,3505,69754,98037,92692,61859,79803,82080,22408,53134,66800,89104,14083,29373,65780,79523,38147,91768,53026,84048,84048,84048];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"515": [
		98037
	],
	"636": [
		17799,
		3505,
		69754,
		98037,
		92692,
		61859,
		79803,
		82080,
		22408
	],
	"1710": [
		41710
	],
	"3026": [
		53026
	],
	"3134": [
		53134
	],
	"4083": [
		14083
	],
	"4252": [
		84048
	],
	"5224": [
		84048
	],
	"5527": [
		5954,
		79803,
		9270,
		13048,
		63720,
		8680,
		56549,
		668,
		14475
	],
	"5780": [
		65780
	],
	"6187": [
		16187
	],
	"6742": [
		84048
	],
	"6800": [
		66800
	],
	"8512": [
		38147,
		91768
	],
	"8766": [
		28766
	],
	"8792": [
		56549,
		668,
		68153,
		28766
	],
	"9104": [
		89104
	],
	"9373": [
		29373
	],
	"9523": [
		79523
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}